"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.showInvaildAgeConfirm = exports.showOwnPhoneConfirm = exports.showFindEmailConfirm = exports.show19YearsDifferenceConfirm = exports.showInvalidCertificationConfirm = exports.showTimeOutConfirm = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const i18n_1 = __importDefault(require("@@/assets/i18n"));
const showTimeOutConfirm = ({ confirm }) => {
    confirm({
        description: ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [i18n_1.default.t('인증시간이 만료되었어요.'), (0, jsx_runtime_1.jsx)("br", {}), i18n_1.default.t('회원님의 보안을 위해 다시 인증해주세요!')] })),
        confirmationText: i18n_1.default.t('확인'),
        cancellationButtonProps: { style: { display: 'none' } },
        allowClose: false,
    });
};
exports.showTimeOutConfirm = showTimeOutConfirm;
const showInvalidCertificationConfirm = ({ confirm }) => {
    confirm({
        description: ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [i18n_1.default.t('앗, 인증이 유효하지 않아요.'), (0, jsx_runtime_1.jsx)("br", {}), `${i18n_1.default.t('다시 인증해 주세요')}:)`] })),
        confirmationText: i18n_1.default.t('확인'),
        cancellationButtonProps: { style: { display: 'none' } },
        allowClose: false,
    });
};
exports.showInvalidCertificationConfirm = showInvalidCertificationConfirm;
const show19YearsDifferenceConfirm = ({ confirm }) => {
    confirm({
        description: ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [i18n_1.default.t('법정대리인과 가입자의 나이 차이가'), (0, jsx_runtime_1.jsx)("br", {}), i18n_1.default.t('19세 미만이라 인증할 수 없어요')] })),
        confirmationText: i18n_1.default.t('확인'),
        cancellationButtonProps: { style: { display: 'none' } },
        allowClose: false,
    });
};
exports.show19YearsDifferenceConfirm = show19YearsDifferenceConfirm;
const showFindEmailConfirm = ({ confirm }) => {
    confirm({
        description: ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [i18n_1.default.t('이미 가입된 번호예요.'), (0, jsx_runtime_1.jsx)("br", {}), i18n_1.default.t('[이메일 찾기]에서 휴대폰 인증된 이메일을'), (0, jsx_runtime_1.jsx)("br", {}), i18n_1.default.t('찾아주세요. 로그아웃 되어요.')] })),
        confirmationText: i18n_1.default.t('이메일 찾기'),
    })
        .then(() => {
        window.location.href = '/login/logout';
    })
        .catch(() => { });
};
exports.showFindEmailConfirm = showFindEmailConfirm;
const showOwnPhoneConfirm = ({ confirm }) => {
    confirm({
        description: ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [i18n_1.default.t('[이름/생년월일]이 같아야 해요.'), (0, jsx_runtime_1.jsx)("br", {}), i18n_1.default.t('도움이 필요하면 1:1문의해주세요!')] })),
        confirmationText: i18n_1.default.t('1:1문의하기'),
    })
        .then(() => {
        window.location.href = '/fondee/qna/';
    })
        .catch(() => { });
};
exports.showOwnPhoneConfirm = showOwnPhoneConfirm;
const showInvaildAgeConfirm = ({ confirm }) => {
    confirm({
        description: ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [i18n_1.default.t('만 8세 부터 ~ 69세까지 본인인증 할 수 있어요.'), (0, jsx_runtime_1.jsx)("br", {}), i18n_1.default.t('그 외 도움이 필요하면 화면을 캡처하여'), (0, jsx_runtime_1.jsx)("br", {}), i18n_1.default.t('1:1문의하기 해주세요.')] })),
        confirmationText: i18n_1.default.t('1:1문의하기'),
    })
        .then(() => {
        window.location.href = '/fondee/qna/';
    })
        .catch(() => { });
};
exports.showInvaildAgeConfirm = showInvaildAgeConfirm;
